import React from 'react';
import { ConfigProvider } from 'antd';
import { Router } from 'router/Router';
import 'antd/dist/reset.css';
import 'styles/global.scss';

const App = () => (
  <ConfigProvider
    theme={{
      hashed: false,
      token: {
        fontFamily: '"Source Sans 3", sans-serif',
        screenXSMin: 0,
        screenXS: 0,
        screenXSMax: 0,
        screenSMMin: 0,
        screenSM: 0,
        screenSMMax: 768,
        screenMDMin: 768,
        screenMD: 768,
        screenMDMax: 1023,
        screenLGMin: 1024,
        screenLG: 1024,
        screenLGMax: 1279,
        screenXLMin: 1280,
        screenXL: 1280,
        screenXLMax: 999999,
        screenXXLMin: 999999,
        screenXXL: 999999,
        colorBgLayout: 'transparent',
        colorText: '#141E2A',
        borderRadius: 2,
        colorError: '#CA202A',
        colorTextPlaceholder: '#87919F',
      },
      components: {
        Tooltip: {
          colorBgSpotlight: '#141E2A',
          colorText: '#ffffff',
          borderRadius: 4,
          fontSize: 12,
          lineHeight: 1.33,
          fontWeightStrong: 400,
        },
      },
    }}
  >
    <Router />
  </ConfigProvider>
);

export default App;
